import React from 'react';
import Helmet from 'react-helmet';

import { PageWrapper, ContactForm } from '../components';


const ContactPage = ({ data }) => (
  <PageWrapper title="Contact Information">
    <Helmet>
      {/* Start of eindocshelp Zendesk Widget script */}
      <script type="text/javascript">
        {`
          /*<![CDATA[*/
          window.zE||(function(e,t,s){var n=window.zE=window.zEmbed=function(){n._.push(arguments)}, a=n.s=e.createElement(t),r=e.getElementsByTagName(t)[0];n.set=function(e){ n.set._.push(e)},n._=[],n.set._=[],a.async=true,a.setAttribute("charset","utf-8"), a.src="https://static.zdassets.com/ekr/asset_composer.js?key="+s, n.t=+new Date,a.type="text/javascript",r.parentNode.insertBefore(a,r)})(document,"script","9127a396-c5aa-46e4-addf-c06d61c32232");
          /*]]>*/
        `}
      </script>
      {/* End of eindocshelp Zendesk Widget script */}
    </Helmet>
    <div className="contentPage">
      <ContactForm supportEmail={data.site.siteMetadata.supportEmail} />
    </div>
  </PageWrapper>
);

export default ContactPage;

export const query = graphql`
  query ContactQuery {
    site {
      siteMetadata {
        domain,
        supportEmail,
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js